module.exports = __webpack_public_path__ + "img/wm-syringe-new.c8ccc789.svg";